/**
 * API för förslagsformuläret (BL-169). Samma inflöde för alla ingångar:
 * POST /api/v1/feedback och POST /api/v1/feedback/{id}/attachments.
 */
import { API_URL, apiFetch } from '../../api';

const BASE = `${API_URL}/api/v1/feedback`;

async function felText(res, reserv) {
  try {
    const body = await res.json();
    return (body && typeof body.detail === 'string' && body.detail) || reserv;
  } catch {
    return reserv;
  }
}

/** Skapar förslaget och returnerar { id, status, type }. */
export async function skapaForslag(anrop) {
  const res = await apiFetch(BASE, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(anrop),
  });
  if (!res.ok) throw new Error(await felText(res, 'Förslaget kunde inte skickas. Försök igen.'));
  return res.json();
}

/** Laddar upp en fil till ett förslag. */
export async function laddaUppFil(id, fil) {
  const form = new FormData();
  form.append('file', fil, fil.name);
  const res = await apiFetch(`${BASE}/${encodeURIComponent(id)}/attachments`, { method: 'POST', body: form });
  if (!res.ok) throw new Error(await felText(res, `${fil.name} kunde inte laddas upp.`));
  return res.json();
}
